"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var theme_1 = __importDefault(require("../../theme"));
var styles_1 = require("./styles");
var SliderController = react_1.memo(function (_a) {
    var values = _a.values, handleValuesChange = _a.handleValuesChange, showLabels = _a.showLabels, min = _a.min, max = _a.max, inputProps = __rest(_a, ["values", "handleValuesChange", "showLabels", "min", "max"]);
    var x0 = values[1] ? (values[0] < values[1] ? values[0] : values[1]) : 0;
    var x1 = values[1]
        ? values[1] > values[0]
            ? values[1]
            : values[0]
        : values[0];
    return (react_1.default.createElement(styles_1.SliderInputsContainer, null,
        react_1.default.createElement(styles_1.SliderRail, { x0: x0, x1: x1, min: min, max: max, railStyle: inputProps.style.rail, trackStyle: inputProps.style.track }),
        values.map(function (value, index) { return (react_1.default.createElement(react_1.Fragment, { key: "slider-" + index },
            react_1.default.createElement(styles_1.SliderInput, __assign({ id: "slider-" + index, index: index, type: "range", percent: values[index] + "%", value: value, min: min, max: max }, inputProps, { onChange: function (event) { return handleValuesChange(event, index); } })))); })));
});
function Slider(_a) {
    var baseValue = _a.value, setBaseValue = _a.setValue, min = _a.min, max = _a.max, step = _a.step, style = _a.style, showLabels = _a.showLabels;
    var _b = react_1.useState(typeof baseValue === "number" ? [baseValue] : baseValue), values = _b[0], setValues = _b[1];
    var handleValuesChange = react_1.useCallback(function (event, index) {
        var newValue = parseInt(event.target.value);
        setValues(function (prevValues) {
            return prevValues.map(function (prevValue, prevIndex) {
                return prevIndex === index ? newValue : prevValue;
            });
        });
        setBaseValue(typeof baseValue === "number"
            ? newValue
            : values.map(function (prevValue, prevIndex) {
                return prevIndex === index ? newValue : prevValue;
            }));
    }, [values, baseValue, setBaseValue]);
    react_1.useEffect(function () {
        var nullBaseValue = baseValue.toString() === "" + min ||
            baseValue.toString() === min + "," + min;
        var nullValues = values.toString() === "" + min || values.toString() === min + "," + min;
        if (nullBaseValue && !nullValues) {
            setValues(typeof baseValue === "number" ? [baseValue] : baseValue);
        }
    }, [baseValue, values, setValues, min]);
    var controllerProps = react_1.useMemo(function () {
        var _a, _b, _c, _d, _e, _f;
        return ({
            min: min || 0,
            max: max || 100,
            step: step || 1,
            values: values,
            handleValuesChange: handleValuesChange,
            style: {
                root: (style === null || style === void 0 ? void 0 : style.root) || {},
                track: {
                    backgroundColor: ((_a = style === null || style === void 0 ? void 0 : style.track) === null || _a === void 0 ? void 0 : _a.backgroundColor) || theme_1.default.colorsPalette.blue.default,
                    height: ((_b = style === null || style === void 0 ? void 0 : style.track) === null || _b === void 0 ? void 0 : _b.height) || 3,
                },
                thumb: {
                    backgroundColor: ((_c = style === null || style === void 0 ? void 0 : style.thumb) === null || _c === void 0 ? void 0 : _c.backgroundColor) || theme_1.default.colorsPalette.blue.default,
                    height: ((_d = style === null || style === void 0 ? void 0 : style.track) === null || _d === void 0 ? void 0 : _d.height) || "14px",
                },
                rail: {
                    backgroundColor: ((_e = style === null || style === void 0 ? void 0 : style.rail) === null || _e === void 0 ? void 0 : _e.backgroundColor) || theme_1.default.colorsPalette.gray.lighter,
                    height: ((_f = style === null || style === void 0 ? void 0 : style.rail) === null || _f === void 0 ? void 0 : _f.height) || 3,
                },
            },
            showLabels: !!showLabels,
        });
    }, [values, handleValuesChange, min, max, step, style, showLabels]);
    return react_1.default.createElement(SliderController, __assign({}, controllerProps));
}
exports.default = Slider;
//# sourceMappingURL=index.js.map